import Vue from 'vue'
import { JSEncrypt } from 'jsencrypt'
import storageUtils from './storageUtils'
const PublicKey =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCLBIQvCu8Fa+bqhEz+dxkwhDm707XUEZHW1qbVunbrqevTAjKwEgpSnnNyy0ha1mlq15UxSi+c/c+YBhZPnkYmgNoO1KzG6wtVAdCwpmG85S9JzzyZ8gD0o0qHSI6XRMwcYaXlV5vNZkfGos6T1OYTYO28fMEuiIl5aln/F1CEgwIDAQAB'
const PrivateKey = ''
/**
 * RSA 加密
 */
export function RSAEncrypt(string) {
  const jse = new JSEncrypt()
  jse.setPublicKey(PublicKey)
  return jse.encrypt(string)
}
/**
 * RSA 解密
 */
export function RSADecrypt(string) {
  const jse = new JSEncrypt()
  jse.setPrivateKey(PrivateKey)
  return jse.decrypt(string)
}
/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Vue.cookie.delete('X-Web-Token')
  storageUtils.removeUser()
}
/**
 * 日期转换
 */
export function formatdate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length),
    )
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str),
      )
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function dateFtt(date, s) {
  var y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate(),
    h = date.getHours(),
    min = date.getMinutes()
  m = m < 10 ? '0' + m : m
  d = d < 10 ? '0' + d : d
  h = h < 10 ? '0' + h : h
  min = min < 10 ? '0' + min : min
  var str = y + '-' + m + '-' + d + (!s ? ' ' + h + ':' + min : '')
  return str
}
export function downloadFile(url, fileName) {
  let preUrl = window.SITE_CONFIG['previewFile'] + url
  if (window.navigator.msSaveOrOpenBlob) {
    // IE version
    // var blob = new Blob([url], { type: 'application/force-download' })
    // window.navigator.msSaveOrOpenBlob(blob, fileName)
    window.open(preUrl)
  } else {
    var x = new XMLHttpRequest()
    x.open('GET', preUrl, true)
    x.responseType = 'blob'
    x.onload = function () {
      var url = window.URL.createObjectURL(x.response)
      var a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()
    }
    x.send()
  }
}
